<div class="individual-profile-page">
  @if (isIndividualLoading() && !individualDto().individualId) {
    <app-loader class="m-auto"/>
  } @else {
    <div class="individual-profile">
      <div class="individual-profile-info d-flex flex-column gap-24">
        <div class="individual-profile-card">
          <div class="personal-info">
            <div class="individual-profile-card-section">
              <app-individual-id-verification
                [individualDto]="individualDto()"
                [currentProviderConnectionStatus]="currentProviderConnectionStatus()"
                (contactChanges)="onContactsChanges($event)"
                (eSignConnectionChanged)="loadESignProvidersStatus()"
              />
            </div>

            <div class="individual-profile-card-section">
              <div class="title-value-group">
                <div class="field">
                  <div class="title">Email address</div>
                  <div class="value">{{ individualDto().primaryContact?.email | defaultValue }}</div>
                </div>
              </div>

              <div class="title-value-group">
                <div class="field">
                  <div class="title">Phone number</div>
                  <div class="value">{{ individualDto().primaryContact?.phone | phone | defaultValue }}</div>
                </div>
              </div>

              @if (contactsViewModel().total) {
                <button
                  type="button"
                  class="btn btn-secondary show-contacts-btn"
                  [disabled]="isLoading()"
                  (click)="setContactVisible()"
                >
                  See All Contacts
                </button>
              } @else {
                <button
                  type="button"
                  class="btn btn-secondary show-contacts-btn"
                  [disabled]="isLoading()"
                  (click)="openAddContactModal()"
                >
                  Add Contact Details
                </button>
              }
            </div>

            <div class="individual-profile-card-section">
              <div
                class="title-value-group"
                placement="top"
                container="body"
                tooltipClass="tooltip-info"
                [ngbTooltip]="differentProfileCardValuesMessage"
                [disableTooltip]="!warningStates().warningStateVisible[UIIndividualWarningStates.Address]"
                [class.warning]="warningStates().warningStateVisible[UIIndividualWarningStates.Address]"
              >
                <div class="field">
                  <div class="title">Address</div>
                  <div class="value">{{ individualDto().address.normalizedFullAddress | defaultValue }}</div>
                </div>

                @if (warningStates().warningStateVisible[UIIndividualWarningStates.Address]) {
                  <div class="actions">
                    <div class="icon-wrapper">
                      <i class="icon ic-alert-triangle-16"></i>
                    </div>

                    <button
                      class="btn btn-icon-transparent bright p-0 d-flex align-items-center justify-content-center"
                      type="button"
                      [disabled]="isLoading()"
                      (click)="openUpdateAddressModal()"
                    >
                      <i class="icon ic-refresh-20"></i>
                    </button>
                  </div>
                }
              </div>
            </div>

            <div class="individual-profile-card-section">
              <div
                class="title-value-group"
                placement="top"
                container="body"
                tooltipClass="tooltip-info"
                [ngbTooltip]="differentProfileCardValuesMessage"
                [disableTooltip]="!warningStates().warningStateVisible[UIIndividualWarningStates.Dob]"
                [class.warning]="warningStates().warningStateVisible[UIIndividualWarningStates.Dob]"
              >
                <div class="field">
                  <div class="title">Date of Birth</div>
                  <div class="value">{{ individualDto().dob | dateFormat | defaultValue }}</div>
                </div>

                @if (warningStates().warningStateVisible[UIIndividualWarningStates.Dob]) {
                  <div class="actions">
                    <div class="icon-wrapper">
                      <i class="icon ic-alert-triangle-16"></i>
                    </div>

                    <button
                      class="btn btn-icon-transparent bright p-0 d-flex align-items-center justify-content-center"
                      type="button"
                      [disabled]="isLoading()"
                      (click)="openUpdateDateOfBirthModal()"
                    >
                      <i class="icon ic-refresh-20"></i>
                    </button>
                  </div>
                }
              </div>

              <div
                class="title-value-group"
                placement="top"
                container="body"
                tooltipClass="tooltip-info"
                [ngbTooltip]="differentProfileCardValuesMessage"
                [disableTooltip]="!warningStates().warningStateVisible[UIIndividualWarningStates.BirthPlace]"
                [class.warning]="warningStates().warningStateVisible[UIIndividualWarningStates.BirthPlace]"
              >
                <div class="field">
                  <div class="title">Place of Birth</div>
                  <div class="value"> {{ placeOfBirth() }}</div>
                </div>

                @if (warningStates().warningStateVisible[UIIndividualWarningStates.BirthPlace]) {
                  <div class="actions">
                    <div class="icon-wrapper">
                      <i class="icon ic-alert-triangle-16"></i>
                    </div>

                    <button
                      class="btn btn-icon-transparent bright p-0 d-flex align-items-center justify-content-center"
                      type="button"
                      [disabled]="isLoading()"
                      (click)="openUpdateBirthPlaceModal()"
                    >
                      <i class="icon ic-refresh-20"></i>
                    </button>
                  </div>
                }
              </div>
            </div>

            <div class="individual-profile-card-section">
              <div class="title-value-group">
                <div class="field">
                  <div class="title">Director ID</div>
                  <div class="value">{{ individualDto().din | din | defaultValue }}</div>
                </div>

                <div class="actions">
                  <button
                    class="btn btn-icon-transparent bright p-0 d-flex align-items-center justify-content-center"
                    type="button"
                    [disabled]="isLoading()"
                    (click)="openEditDinModal()"
                  >
                    <i class="icon ic-edit-16"></i>
                  </button>
                </div>
              </div>

              <div class="title-value-group">
                <div class="field">
                  <div class="title">Family Group</div>
                  <div class="value"> {{ individualDto().familyGroup | defaultValue }}</div>
                </div>

                <div class="actions">
                  <button
                    class="btn btn-icon-transparent bright p-0 d-flex align-items-center justify-content-center"
                    type="button"
                    [disabled]="isLoading()"
                    (click)="openEditFamilyGroupModal()"
                  >
                    <i class="icon ic-edit-16"></i>
                  </button>
                </div>
              </div>

              <div class="title-value-group">
                <div class="field">
                  <div class="title">Reference Number</div>
                  <div class="value"> {{ individualDto().referenceNumber | defaultValue }}</div>
                </div>

                <div class="actions">
                  <button
                    class="btn btn-icon-transparent bright p-0 d-flex align-items-center justify-content-center"
                    type="button"
                    [disabled]="isLoading()"
                    (click)="openEditReferenceNumberModal()"
                  >
                    <i class="icon ic-edit-16"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          @if (isXpmConnected()) {
            <div class="individual-profile-card-section">
              <app-xpm-card-profile
                [(externalEntities)]="individualDto().externalEntities"
                [entityId]="individualDto().individualId"
                [disableControls]="false"
                [entityType]="entityType"
              />
            </div>
          }
        </div>

        <div class="individual-tags pb-4">
          <app-entity-profile-tags
            dropdownPlacement="top-right"
            [disableControls]="isControlsDisabled()"
            [entityProfile]="individualDto()"
          />
        </div>
      </div>

      <div class="individual-entities">
        <div class="card">
          <div class="card-header d-flex align-items-stretch justify-content-start flex-row gap-24">
            <app-tab-button
              iconClass="ic-entities-20"
              [isActive]="true"
              [isDisabled]="isControlsDisabled()"
            >
              Entities
            </app-tab-button>

            <app-divider [vertical]="true"/>

            <app-tab-button
              iconClass="ic-mail-20"
              [isActive]="contactsViewModel().isVisible"
              [isDisabled]="isControlsDisabled()"
              (tabClicked)="setContactVisible()"
            >
              {{ contactsViewModel().label }}
            </app-tab-button>

            <app-tab-button
              iconClass="ic-alert-triangle-16"
              [isActive]="alertsViewModel().isVisible || isLoading()"
              [isDisabled]="!alertsViewModel().isVisible || isControlsDisabled()"
              (tabClicked)="setAlertsVisible(!!alertsViewModel().total)"
            >
              {{ alertsViewModel().label }}
            </app-tab-button>

            <app-tab-button
              *appHasRole="['Admin', 'Manager', 'Preparer']"
              iconClass="ic-notes-20"
              [isActive]="notesViewModel().isVisible"
              [isDisabled]="isControlsDisabled()"
              (tabClicked)="setNotesVisible()"
            >
              {{ notesViewModel().label }}
            </app-tab-button>
          </div>

          <div class="individual-profile-content font-weight-bold">
            <app-grid-client-side
              [loading]="isLoading()"
              [colDefs]="$any(colDefs())"
              [rowData]="individualRelationshipsViewModel().relationships"
              [gridOptions]="gridOptions"
              [totalRows]="individualRelationshipsViewModel().relationships.length"
              (gridReady)="onGridReady($event)"
              (select)="onIndividualSelect($event)"
            >

              <div class="grid-controls-middle h-100 d-flex align-items-center gap-2">
                <div class="flex-grow-1">
                  @if (individualRelationshipsViewModel().isShowPastOfficersToggleVisible) {
                    <label class="d-flex align-items-center gap-2 mb-0">
                      <app-toggle-button
                        [switched]="individualRelationshipsViewModel().isPastOfficersVisible"
                        [disabled]="isLoading()"
                        (switchBtn)="setIsPastOfficersVisible($event)"
                      />

                      <span class="font-size-14">Show Past Officers</span>
                    </label>
                  }
                </div>

                @if (checkedIndividualRelationships.length) {
                  <div
                    ngbDropdown
                    class="dropdown"
                    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
                  >
                    <button
                      ngbDropdownToggle
                      id="individual-entities-bulk-actions-dd"
                      type="button"
                      class="btn btn-primary d-flex align-items-center gap-8"
                      [disabled]="isLoading()"
                    >
                      <span>Bulk Actions</span>
                      <i class="icon ic-select-20"></i>
                    </button>

                    <div
                      ngbDropdownMenu
                      aria-labelledby="individual-entities-bulk-actions-dd"
                      class="dropdown-menu common-dropdown-menu"
                    >
                      <div
                        ngbDropdownItem
                        class="dropdown-item"
                        (click)="openUpdateRelationshipContactDetails()"
                      >
                        <i class="icon ic-refresh-20"></i>
                        <span class="title">Update Contact Details</span>
                      </div>

                      <div class="dropdown-section-header">
                        Forms
                      </div>

                      <div
                        ngbDropdownItem
                        class="dropdown-item document-dropdown-item"
                        (click)="openCompanyChangePartyNameModalBulk()"
                      >
                        <i class="icon ic-change-officer-name-20"></i>
                        <div>
                          <div class="title">Change Name</div>
                          <div class="asic-form">Form 484A2</div>
                        </div>
                      </div>

                      <div
                        ngbDropdownItem
                        class="dropdown-item document-dropdown-item"
                        (click)="openSelectBulkChangeAddressMethodModal()"
                      >
                        <i class="icon ic-change-address-20"></i>
                        <div>
                          <div class="title">Change Address</div>
                          <div class="asic-form">Form 484A1</div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div class="grid-controls-end">
                <button
                  type="button"
                  class="btn btn-secondary"
                  [disabled]="isLoading()"
                  (click)="onExportIndividuals()"
                >
                  <i class="icon ic-download-20"></i>
                </button>
              </div>
            </app-grid-client-side>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<app-contacts
  [individual]="individualDto()"
  [opened]="contactsViewModel().isVisible"
  (close)="setContactVisible(false)"
  (contactsChanged)="onContactsChanges($event)"
/>

<app-notes
  [individualId]="individualDto().individualId"
  [opened]="notesViewModel().isVisible"
  (close)="setNotesVisible(false)"
  (notesTotalChanged)="onNotesTotalChange($event)"
/>

<app-alerts-list
  [alerts]="individualDto().alerts"
  [entityType]="EntityType.Individual"
  [individual]="individualDto()"
  [opened]="alertsViewModel().isVisible"
  (close)="setAlertsVisible(false)"
/>
